import { Dispatch, useRef } from 'react';
import { SearchAction } from './state/actions';

export const useReset = ({
    dispatch,
    resetAbortController,
}: {
    dispatch: Dispatch<SearchAction>;
    resetAbortController: () => void;
}) => {
    const isAfterReset = useRef(false);
    const setIsAfterReset = (value: boolean) => {
        isAfterReset.current = value;
    };
    const resetState = (payload: { exceptInstantSearch?: boolean } = { exceptInstantSearch: false }) => {
        dispatch({
            type: 'reset-state',
            payload: {
                exceptInstantSearch: payload.exceptInstantSearch,
            },
        });
        setIsAfterReset(true);
        resetAbortController();
    };
    return {
        isAfterReset,
        setIsAfterReset,
        resetState,
    };
};
